/* =============================================================================
   LOOMA — cart controllers (spec §11 Phase 5)
   <looma-cart-drawer>  slide-out bag: open/close, focus-trap, Esc, qty, remove,
                        whole-page Section refresh (works from any page).
   <looma-coupon>       collapsible discount-code apply (/discount/{code}).
   <looma-cart-page>    cart-page qty/remove enhancement (change → reload).
   No-JS safe: header cart icon is a real <a href="/cart">; cart page is a
   plain <form> POSTing to /cart with url_to_remove links.
   ========================================================================== */
(function () {
  'use strict';

  function changeUrl() {
    return (window.routes && window.routes.cart_change_url) || '/cart/change.js';
  }
  function postChange(payload) {
    return fetch(changeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }
  var FOCUSABLE = 'a[href],button:not([disabled]),input,textarea,[tabindex]:not([tabindex="-1"])';

  /* ---- <looma-cart-drawer> ----------------------------------------------- */
  if (!customElements.get('looma-cart-drawer')) {
    customElements.define('looma-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        this._opener = null;
        this._onKey = this._onKey.bind(this);
        this._bind();
      }
      _bind() {
        this.panel = this.querySelector('.cart-drawer');
        var self = this;
        this.onclick = function (e) {
          if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); return; }
          var up = e.target.closest('[data-qty-up]');
          var dn = e.target.closest('[data-qty-down]');
          var rm = e.target.closest('[data-remove]');
          if (up || dn) {
            e.preventDefault();
            var line = +(up || dn).dataset.line;
            var input = self.querySelector('[data-qty-input][data-line="' + line + '"]');
            var q = input ? parseInt(input.value, 10) || 1 : 1;
            self._set(line, up ? q + 1 : Math.max(0, q - 1));
          } else if (rm) {
            e.preventDefault();
            self._set(+rm.dataset.line, 0);
          }
        };
        this.addEventListener('click', this.onclick);
        this.querySelectorAll('[data-qty-input]').forEach(function (inp) {
          inp.addEventListener('change', function () {
            self._set(+inp.dataset.line, Math.max(0, parseInt(inp.value, 10) || 0));
          });
        });
      }
      _set(line, qty) {
        if (this.classList.contains('is-busy')) return;
        this.classList.add('is-busy');
        var self = this;
        postChange({ line: line, quantity: qty })
          .then(function () { return self.refresh(); })
          .catch(function () {})
          .then(function () { self.classList.remove('is-busy'); });
      }
      refresh() {
        var self = this, wasOpen = this.classList.contains('is-open');
        return fetch(location.pathname + location.search, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('looma-cart-drawer');
          if (fresh) { self.innerHTML = fresh.innerHTML; self.className = fresh.className; }
          if (wasOpen) self.classList.add('is-open');
          var fb = doc.querySelector('#cart-icon-bubble'), b = document.getElementById('cart-icon-bubble');
          if (fb && b) b.innerHTML = fb.innerHTML;
          self._bind();
          window.Looma && window.Looma.emit && window.Looma.emit('looma:cart:updated', {});
        }).catch(function () {});
      }
      open() {
        if (this.classList.contains('is-open')) return;
        this._opener = document.activeElement;
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('no-scroll');
        document.addEventListener('keydown', this._onKey);
        var f = this.querySelector('[data-cart-close]') || this.panel;
        if (f) f.focus();
      }
      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
        document.removeEventListener('keydown', this._onKey);
        if (this._opener && this._opener.focus) this._opener.focus();
      }
      _onKey(e) {
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key !== 'Tab') return;
        var nodes = [].slice.call(this.panel.querySelectorAll(FOCUSABLE))
          .filter(function (n) { return n.offsetParent !== null; });
        if (!nodes.length) return;
        var first = nodes[0], last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---- <looma-coupon> ---------------------------------------------------- */
  if (!customElements.get('looma-coupon')) {
    customElements.define('looma-coupon', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var toggle = this.querySelector('[data-coupon-toggle]');
        var form = this.querySelector('[data-coupon-form]');
        var apply = this.querySelector('[data-coupon-apply]');
        var input = this.querySelector('[data-coupon-input]');
        if (toggle && form) {
          toggle.addEventListener('click', function () {
            form.hidden = !form.hidden;
            if (!form.hidden && input) input.focus();
          });
        }
        if (apply) apply.addEventListener('click', function () { self._apply(); });
        if (input) input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); self._apply(); }
        });
      }
      _msg(text, ok) {
        var m = this.querySelector('[data-coupon-msg]');
        if (!m) return;
        m.hidden = false;
        m.textContent = text;
        m.classList.toggle('is-ok', !!ok);
        m.classList.toggle('is-err', !ok);
      }
      _apply() {
        var input = this.querySelector('[data-coupon-input]');
        var code = input ? input.value.trim() : '';
        if (!code) return;
        var self = this;
        this.classList.add('is-busy');
        fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
          .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var codes = (cart && cart.discount_codes) || [];
            var hit = codes.filter(function (c) {
              return c.code && c.code.toLowerCase() === code.toLowerCase();
            })[0];
            self.classList.remove('is-busy');
            if (hit && hit.applicable) {
              self._msg(self._t('ok'), true);
              var drawer = self.closest('looma-cart-drawer');
              if (drawer && drawer.refresh) drawer.refresh(); else location.reload();
            } else {
              self._msg(self._t('err'), false);
            }
          })
          .catch(function () { self.classList.remove('is-busy'); self._msg(self._t('err'), false); });
      }
      _t(kind) {
        var d = window.LoomaCartStrings || {};
        if (kind === 'ok') return d.couponOk || 'Applied!';
        return d.couponErr || "That code didn't work";
      }
    });
  }

  /* ---- <looma-cart-page> ------------------------------------------------- */
  if (!customElements.get('looma-cart-page')) {
    customElements.define('looma-cart-page', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (e) {
          var up = e.target.closest('[data-qty-up]');
          var dn = e.target.closest('[data-qty-down]');
          var rm = e.target.closest('[data-remove]');
          if (up || dn) {
            e.preventDefault();
            var line = +(up || dn).dataset.line;
            var inp = self.querySelector('[data-qty-input][data-line="' + line + '"]');
            var q = inp ? parseInt(inp.value, 10) || 1 : 1;
            self._set(line, up ? q + 1 : Math.max(0, q - 1));
          } else if (rm) {
            e.preventDefault();
            self._set(+rm.dataset.line, 0);
          }
        });
        this.querySelectorAll('[data-qty-input]').forEach(function (inp) {
          inp.addEventListener('change', function () {
            self._set(+inp.dataset.line, Math.max(0, parseInt(inp.value, 10) || 0));
          });
        });
      }
      _set(line, qty) {
        if (this._busy) return;
        this._busy = true;
        this.classList.add('is-busy');
        postChange({ line: line, quantity: qty })
          .then(function () { location.reload(); })
          .catch(function () { location.reload(); });
      }
    });
  }

  /* ---- header cart icon opens the drawer (no-JS falls back to /cart) ------ */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('#cart-icon-bubble, [data-cart-toggle]');
    if (!trigger) return;
    var drawer = document.querySelector('looma-cart-drawer');
    if (!drawer || !drawer.open) return;
    e.preventDefault();
    drawer.open();
  });
})();
